module.exports = __webpack_public_path__ + "img/member-avatar.255411f3.svg";